module.exports = __webpack_public_path__ + "img/guide_pic.f209b74a.png";